import React, { useEffect, useMemo, useState, useRef } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import _ from 'lodash';
import Select from 'react-select';
import { Button } from 'react-bootstrap';

import MaterialTable, { MTableBody } from '@material-table/core';
import MTableHeader from '../../../material-table-overrides/MTableHeader';
import MTableFilterRow from '../../../material-table-overrides/MTableFilterRow';
import ProgramBuysFooter from '../../../../pages/reports/tabsAccounting/ProgramBuysFooter';// todo
import { getColumns, getFilters } from './tableProjectRegister';
import {localization, modifyDefaultOptions} from '../../../../helpers/table';

import { status as PS } from '../../../../helpers/passport';
import { tableIcons, years } from '../../../../helpers';

import useAPI from '../../../../hooks/useAPI';
import useToast from '../../../../hooks/useToast';
import useUserContext from '../../../../hooks/useUserContext';

import ConfirmModal from '../../ConfirmModal';

import { isAdmin, isProjectAdmin } from '../../../../services/rolesSvc';
import PassportVersionHistoryModal from "../../../../pages/project/PassportVersionHistoryModal";
import LoadingTable from '../../../table/LoadingTable';

const modifiedYears = [
  { value: null, label: 'Все периоды' },
  ...years.map((val) => ({ value: val, label: val }))];

export default function TabProjectRegister() {
  const api = useAPI();
  const toast = useToast();

  const MTableFiltersRef = useRef({});
  const defaultYear = new Date().getFullYear();
  const { stratId, policyId, portfolioId } = useParams();

  const [selYear, setSelYear] = useState({ value: defaultYear, label: defaultYear });
  const [selectedTags, setSelectedTags] = useState([]);
  const [tagOptions, setTagOptions] = useState([]);
  const handleInputChange = async (val) => {
    setSelYear(val);
  };

  // #region Perms
  const userCtx = useUserContext();
  const canDeleteProj = (proj) => proj.status === PS.draft && proj.version === 1
        && (isProjectAdmin(userCtx, proj.originId) || isAdmin(userCtx));
    // #endregion

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [projects, setProjects] = useState([]);
  const [externalLookups, setExternalLookups] = useState({});
  const [isModalDeleteProj, setIsModalDeleteProj] = useState({ show: false, value: null });
  const [passportHistoryModal, setPassportHistoryModal] = useState(null);

  const filters = useMemo(() => getFilters(projects), [projects]);
  const cols = useMemo(() => getColumns((stratId ? portfolioId ? 'onPortf' : 'onStrat' : 'onPolicy'), filters, externalLookups, setPassportHistoryModal, userCtx, canDeleteProj, setIsModalDeleteProj, projects, MTableFiltersRef),
    [stratId, policyId, portfolioId, filters, externalLookups, setPassportHistoryModal, userCtx, canDeleteProj, setIsModalDeleteProj]);


  useEffect(async () => {
    await getData(selYear.value); // первичный запрос данных с фильтром по году по умолчанию

    // сразу запрашиваем все фильтры
    const resLookups = await Promise.all([
      api.get('/mng/agreements'),
      api.get('/mng/bcCodes'),
      api.get('/mng/funding'),
      api.get('/mng/proj/types')]);
    setExternalLookups({
      agreements: arrayToLookup(resLookups[0], 'num'),
      bcCodes: arrayToLookup(resLookups[1], 'fullCode'),
      funding: arrayToLookup(resLookups[2], 'code'),
      projTypes: arrayToLookup(resLookups[3], 'id', 'name'),
    });
  }, []);

  const getData = async (year, tags) => {
    try {
      const yearQuery = year ? `year=${year}&` : '';
      const tagsQuery = tags && tags.length  ? `labels=[${tags}]&` : '';
      const result = await api.get(`/projs?${yearQuery}${tagsQuery}strategyId=${stratId || 0}&portfId=${portfolioId || 0}&policyId=${policyId || 0}&latest=true`);
      if(tagOptions.length === 0){
        setTagOptions([
          {label: 'Проекты без тега', value: -1},
          ...result.reduce((acc, project) => {
            const uniqueTags = []
            project.labels.forEach(tag => {
              if (!acc.some(opt => opt.value === tag.id)){
                uniqueTags.push({label: tag.name, value: tag.id })
              }
            })
            return [...acc, ...uniqueTags]
          }, [])
        ]);
      }
      setIsLoaded(true);
      setProjects(result.map((e) => ({
        ...e, 
        policyAreaName: e.policyArea.name,
        headName: e.head ? e.head.displayName : ""
      }) ));
    } catch (error) {
      setIsLoaded(true);
      setError(error);
    }
  };

  const handleDeleteProj = async () => {
    const result = await api.del(`/projs/${isModalDeleteProj.value}`, { id: isModalDeleteProj.value });
    if (result && !result.error) {
      toast.success('Проект успешно удален');
      setProjects((prev) => prev.filter((v) => v.id !== isModalDeleteProj.value));
    }
    setIsModalDeleteProj({ show: false, value: null });
  };

  // #region Lookups for filters
  /** Превращает массив объектов в объект формата { значение: заголовок },
     * который требуется для поля lookup в параметрах столбца
     */
  const arrayToLookup = (values, valueField, titleField) => (values && values.length > 0
    ? Object.fromEntries(values.map((v) => [v[valueField], v[titleField || valueField]]))
    : {});
  // #endregion

  useEffect(() => {
    getData(selYear?.value, selectedTags)
  }, [selYear, selectedTags]);

  if (error) {
    return (
      <div style={{ color: 'red', background: 'white' }}>
        Ошибка:
        {error.message}
      </div>
    );
  }
  return (
    <div className="tab-subproject-register" style={{ color: 'initial' }}>
      <div style={styledContainer}>
        <div>
          <Select
            placeholder="Выберите год"
            defaultValue={[{ value: defaultYear, label: defaultYear }]}
            name="yearsSingle"
            options={modifiedYears}
            onChange={handleInputChange}
            value={selYear}
            isSearchable={false}
          />
        </div>
        <div style={{ marginLeft: 16 }}>
          <NavLink to={policyId
            ? `/policies/${policyId}/projs/new`
            : `/strats/${stratId}${portfolioId ? `/portfolios/${portfolioId}` : ''}/projs/new`}
          >
            <Button variant="primary">Добавить проект</Button>
          </NavLink>
        </div>
        <div className='ms-3'>
          <Select
            placeholder=""
            noOptionsMessage={(_) => 'Тегов не найдено'}
            options={tagOptions}
            value={
              selectedTags.length
                ? tagOptions.filter(opt => selectedTags.includes(opt.value))
                : { label: 'Все теги', value: null }
            }
            onChange={(opts) => setSelectedTags(opts.filter(opt => opt.value)
              .map(opt => opt.value))}
            isMulti
            closeMenuOnSelect={false}
          />
        </div>

      </div>
      <div style={styledTable}>
        <LoadingTable spinnerStyle={{marginTop: '70px'}} loadingObject={{isLoaded}}>
        <MaterialTable
          components={{
            Container: (props) => <div className="special-filter" {...props} />,
            Header: (props) => (<MTableHeader {...props} tableHeadStyle={styledHeaderSticky} />),
            FilterRow: (props) => (<MTableFilterRow {...props} />),
            Body: (_props) => (
              <>
                <MTableBody {..._props} />
                <ProgramBuysFooter {..._props} isSticky stickyConfig={{ total: { colspan: 4 }, valueCells: {0: {colspan: 3, textOffset: 140}}}}/>
              </>
            ),
          }}
          title=""
          options={modifyDefaultOptions({
            pageSize: 10,
            pageSizeOptions: [10, 30, 50],
            headerStyle: {
              fontSize: 12,
              lineHeight: 1.3,
              padding: '8px 16px',
            },
            filterCellStyle: {
              padding: '8px 16px',
            },
            filtering: true,
            sorting: true,
            search: false,
            paging: false,
            maxBodyHeight: 'calc(100vh - 400px)',
          })}
          icons={tableIcons}
          localization={localization}
          columns={cols}
          data={projects}
        />
        </LoadingTable>
      </div>
      {passportHistoryModal && <PassportVersionHistoryModal pass={passportHistoryModal} onClose={() => setPassportHistoryModal(null)} />}
      <ConfirmModal
        show={isModalDeleteProj.show}
        onClose={() => setIsModalDeleteProj({ show: false, value: null })}
        onConfirm={() => handleDeleteProj()}
        headerText="Удаление проекта"
        message="Проект будет удален, данное действие нельзя отменить. Удалить проект?"
      />
    </div>
  );
}

const styledTable = {
  maxWidth: '100%',
  marginTop: 32,
};
const styledContainer = {
  display: 'flex',
  zIndex: 12,
  position: 'relative',
  top: 84,
  marginTop: -90,
};
const styledHeaderSticky = { position: 'sticky', top: 0, zIndex: 10 };
